import * as React from "react";
import type { SVGProps } from "react";
const SvgIconMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m5.78 1.07-1.84.46C2.01 2 2.01 2 1.77 2.17c-.22.15-.45.43-.57.69l-.1.26-.04.15v4.96c0 4.05 0 4.98.03 5.07.13.64.57 1.12 1.2 1.3.16.04.47.05.63.03l1.54-.38 1.42-.35 2.1.52c1.86.47 2.11.53 2.19.52l1.89-.47c1.42-.35 1.83-.46 1.93-.5.4-.19.72-.55.86-.95.1-.28.09.08.09-5.28 0-4.02 0-4.95-.02-5.04-.14-.64-.58-1.12-1.22-1.3-.15-.04-.46-.05-.62-.03l-1.54.38-1.42.35-2.1-.52c-1.93-.49-2.16-.54-2.24-.51m-1.9 1.65-1.43.37c-.08.04-.18.18-.21.27-.03.08-.03.43-.03 4.91 0 5.44-.02 4.9.13 5.06q.12.15.3.17c.07 0 .24-.03 1.38-.32l1.3-.32V7.61c0-4.18-.01-5.24-.03-5.24zm2.57 4.9v5.24l1.54.39 1.55.38.01-5.24V3.14l-1.54-.39-1.55-.38zm5.52-4.8-1.28.32v10.49c.05 0 2.8-.7 2.84-.72.1-.05.2-.17.24-.27.02-.08.02-.43.02-4.91 0-5.44.02-4.9-.13-5.06q-.13-.15-.32-.17c-.07 0-.25.04-1.37.32"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconMap;
